import { getQueryParams } from 'utils';
import { baseApi } from './baseApi';
import { QueryParams, TAG_TYPES } from 'types';

const import_products = 'import-products';
const export_products = 'export-products';
const importProductserviceApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getExportProducts: builder.query<
      {
        filePath: string;
        fileUrl: string;
      },
      {
        query: QueryParams;
      }
    >({
      query: (params) => {
        const query = getQueryParams(params.query);
        if (query == '') return { url: export_products, method: 'GET' };
        console.log(`${query}`);
        return {
          url: `${export_products}?${query}`,
          method: 'GET',
        };
      },
    }),
    createImportproducts: builder.mutation<{ success: boolean; data: string }, { filePath: string; fileType: string }>({
      query: (data) => {
        return {
          url: import_products,
          method: 'POST',
          data,
        };
      },
      invalidatesTags: [{ type: TAG_TYPES.Product, id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetExportProductsQuery, useLazyGetExportProductsQuery, useCreateImportproductsMutation } =
  importProductserviceApiService;
